import PolygonTable from "../../../views/Polygon";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const polygonRoutes = [
  {
    path: "/polygons",
    component: PolygonTable,
    exact: true,
    menuName: MenuNames.POLYGON,
  },
  {
    menuName: MenuNames.POLYGON,
    path: "/polygons/:id",
    component: PolygonTable,
    exact: true,
  },
  {
    path: "/polygons-types",
    component: PolygonTable,
    exact: true,
    menuName: MenuNames.POLYGON,
  },
];

export default polygonRoutes;
